import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/affiliate-program/loading.js");
